import { memo, useCallback, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import _map from 'lodash/map';
// Local files
import { CardItem, StyledList } from './List.styled';
import Item from './Item/Item';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useSuperbillGoals from 'hooks/useSuperbillGoals';
import { superbillGoalsSelectors } from 'features/superbillGoals';

const SuperbillGoalsList = () => {
  const { setSuperbillGoalDrawer } = useApp();
  const { getSuperbillGoals, clearLocalSuperbillGoals } = useSuperbillGoals();
  const { data, pagination } = useCustomSelector(superbillGoalsSelectors.getSuperbillGoalsData);
  const fetching = useCustomSelector(superbillGoalsSelectors.superbillGoalsIsFetching);

  const fetchSuperbillGoals = useCallback((offset) => {
    getSuperbillGoals({ offset });
  }, [getSuperbillGoals]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchSuperbillGoals(pagination.limit + pagination.offset);
  const handleAdd = () => setSuperbillGoalDrawer({ open: true, edit: false, id: '' });

  useEffect(() => {
    
    return () => {
      clearLocalSuperbillGoals();
    }
  }, [clearLocalSuperbillGoals]);

  return (
    <Card sx={{ p: 2, mt: 3 }}>
      <CardItem>
        <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>Daily Email Recipients</Typography>
        <Button variant='outlined' disabled={fetching} onClick={handleAdd}>Add</Button>
      </CardItem>
      <StyledList onScroll={handleScroll}>
        {_map(data, (item) => <Item key={item.id} {...item} />)}
        {fetching && <ListSkeleton />}
        {data.length === 0 && !fetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No emails</Typography>}
      </StyledList>
    </Card>
    
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SuperbillGoalsList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);